import { render, staticRenderFns } from "./PlayerCard.vue?vue&type=template&id=3758e225&scoped=true&"
import script from "./PlayerCard.vue?vue&type=script&lang=js&"
export * from "./PlayerCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCard.vue?vue&type=style&index=0&id=3758e225&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3758e225",
  null
  
)

export default component.exports